import pincodeValidation from 'shared/validation/pincodeValidation';
import { object, string } from 'yup';

export const Fields = [
  {
    name: 'streetlocality',
    placeholder: 'Street/Locality',
    label: 'Street/Locality',
  },
  {
    name: 'province',
    placeholder: 'Province',
    label: 'Province',
  },
  {
    name: 'city',
    placeholder: 'City',
    label: 'City',
  },
  {
    name: 'postalcode',
    placeholder: 'Postal Code',
    label: 'Postal Code',
    // addonbefore:'+1'
  },
  {
    name: 'country',
    placeholder: 'Country',
    label: 'Country',
  },
];

export const validationSchema = object({
  streetlocality: string().required('Required'),
  province: string().required('Required'),
  city: string().required('Required'),
  postalcode: string().matches(pincodeValidation, "Please don't use special characters").required('Required'),
  country: string().required('Required'),
});
export const initialValues = {
  streetlocality: '',
  province: '',
  city: '',
  postalcode: '',
  country: '',
};
